<template>
  <div>
    <div class="file-item-body" :class="{'file-item-selected' : fileItem.selected}">
      <div class="item-selected" @click="clickSelectedItem" v-if="fileItem.data_type != 3 && showCkeakBtn">
        <img v-if="!fileItem.selected" src="@/assets/ic_selected_n.png" alt="" />
        <img v-else src="@/assets/ic_selected_y.png" alt="" />
      </div>
      <div class="item-body">
        <div class="file-icon">
          <img v-if="(fileItem.file_type == 1 || fileItem.file_type == 2) && (fileItem.thumb != '' && fileItem.thumb != null)" :src="fileItem.thumb" alt="Icon" />
          <img v-else :src="fileIcon[fileItem.file_type]" alt="Icon" />
        </div>
        <div class="file-content">
          <div class="file-name">
            {{ fileItem.title }}
          </div>
          <div class="file-time">
            {{ fileItem.createtime }} <label v-if="fileItem.data_type != 3">{{ fileItem.size }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  import fileIcon from '@/utils/file_icon.js';
  export default {
    // import引入的组件需要注入到对象中才能使用
    components: {},
    props: {
      fileItem: {
        type: Object,
        required: true
      },
      showCkeakBtn: {
        type: Boolean,
        default: true
      }
    },
    data() {
      // 这里存放数据
      return {
        fileIcon,
      }
    },
    // 过滤器
    filters: {},
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
      clickSelectedItem(event) {
        event.stopPropagation();
        this.$emit('clickSelectedItem', this.fileItem);
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    ctivated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style lang='scss' scoped>
  .file-item-body {
    display: flex;
    align-items: center;
    padding: 0 24px;
    height: 60px;
    .item-selected {
      width: 14px;
      height: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 22px;
      img {
        width: 14px;
        height: 14px;
        object-fit: cover;
      }
    }
    .item-body {
      display: flex;
      align-items: center;
      .file-icon {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        /* margin: 0 16px 0 22px; */
        img {
          width: 32px;
          height: 32px;
          border-radius: 3px;
          object-fit: cover;
        }
      }
      .file-content {
        display: flex;
        flex-direction: column;
        margin-left: 16px;
        .file-name {
          font-size: 13px;
          font-weight: bold;
          margin-bottom: 4px;
          word-break: break-all;
          word-wrap: break-word;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 1.2;
          max-height: 2.4em;
        }
        .file-time {
          font-size: 10px;
          color: #999999;
        }
      }
    }
  }
  .file-item-selected {
    background-color: #EDF3FF;
  }
  .file-item-body:hover {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/file_item.vue